import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import proyectosStyles from "../Styles/proyectos.module.css"
import homebanking from "../images/homebanking.png"
import rompecabezas from "../images/rompecabezas.png"
import pixelArt from "../images/pixelArt.png"
import ciudadZombie from "../images/ciudad-zombie.png"
import reservando from "../images/reservando.png"
import qoeVeoHoy from "../images/queveohoy.png"

const Proyectos = () => {
  return (
    <Layout>
      <SEO title="Proyectos" />
      <div className={proyectosStyles.container}>
        <ul className={proyectosStyles.ul}>
          <li>
            <a
              className={proyectosStyles.a}
              href="https://guillermoalfredorl.github.io/HomeBanking/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={proyectosStyles.img}
                src={homebanking}
                alt="proyecto home banking"
              ></img>
              <h3>Home Banking</h3>
            </a>
          </li>
          <li>
            <a
              className={proyectosStyles.a}
              href="https://guillermoalfredorl.github.io/RompeCabezas/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={proyectosStyles.img}
                src={rompecabezas}
                alt="proyecto rompecabezas"
              ></img>
              <h3>Rompecabezas</h3>
            </a>
          </li>
          <li>
            <a
              className={proyectosStyles.a}
              href="https://guillermoalfredorl.github.io/PixelArt/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={proyectosStyles.img}
                src={pixelArt}
                alt="Proyecto pixel art"
              ></img>
              <h3>Pixel art</h3>
            </a>
          </li>
          <li>
            <a
              className={proyectosStyles.a}
              href="https://guillermoalfredorl.github.io/CiudadZombie/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={proyectosStyles.img}
                src={ciudadZombie}
                alt="Proytecto ciudad zombie"
              ></img>
              <h3>Ciudad Zombie</h3>
            </a>
          </li>
          <li>
            <a
              className={proyectosStyles.a}
              href="https://reservando.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={proyectosStyles.img}
                src={reservando}
                alt="Proyecto reservando"
              ></img>
              <h3>Reservando</h3>
            </a>
          </li>
          <li>
            <a
              className={proyectosStyles.a}
              href="https://queveohoy.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={proyectosStyles.img}
                src={qoeVeoHoy}
                alt="Proyecto que veo hoy"
              ></img>
              <h3>Que veo hoy</h3>
            </a>
          </li>
        </ul>
      </div>
    </Layout>
  )
}

export default Proyectos
